if (!customElements.get('ee-inside-formula-carousel')) {
  customElements.define(
    'ee-inside-formula-carousel',
    class EeInsideFormulaCarousel extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;

        this.index = 0;
        this.position = 0;
        this.animating = false;
        this.onPrev = this.prev.bind(this);
        this.onNext = this.next.bind(this);
        this.onVisualClick = this.handleVisualClick.bind(this);
        this.onPointerDown = this.handlePointerDown.bind(this);
        this.onPointerUp = this.handlePointerUp.bind(this);
        this.onKeyDown = this.handleKeyDown.bind(this);
        this.onTransitionEnd = this.handleTransitionEnd.bind(this);
        this.onResize = this.handleResize.bind(this);

        this.visual = this.querySelector('[data-eif-visual]');
        this.track = this.querySelector('[data-eif-visual-track]');
        this.heading = this.querySelector('[data-eif-heading]');
        this.content = this.querySelector('[data-eif-content]');
        this.productTitle = this.querySelector('[data-eif-product-title]');
        this.prevBtn = this.querySelector('[data-eif-prev]');
        this.nextBtn = this.querySelector('[data-eif-next]');
        this.headingSlides = this.heading ? Array.from(this.heading.children) : [];
        this.contentSlides = this.content ? Array.from(this.content.children) : [];
        this.titleSlides = this.productTitle ? Array.from(this.productTitle.children) : [];
        this.realSlides = this.track ? Array.from(this.track.children) : [];
        this.total = this.realSlides.length;

        if (!this.visual || !this.track || !this.total) return;

        this.realSlides.forEach(function (slide, index) {
          slide.setAttribute('data-eif-index', String(index));
        });

        if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
        this.visual.addEventListener('click', this.onVisualClick);
        this.visual.addEventListener('pointerdown', this.onPointerDown);
        this.visual.addEventListener('pointerup', this.onPointerUp);
        this.track.addEventListener('transitionend', this.onTransitionEnd);
        this.addEventListener('keydown', this.onKeyDown);
        window.addEventListener('resize', this.onResize);
        if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');

        this.goTo(0, true);
        this.classList.add('is-ready');
        this.ready = true;
      }

      disconnectedCallback() {
        if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
        if (this.visual) {
          this.visual.removeEventListener('click', this.onVisualClick);
          this.visual.removeEventListener('pointerdown', this.onPointerDown);
          this.visual.removeEventListener('pointerup', this.onPointerUp);
        }
        if (this.track) this.track.removeEventListener('transitionend', this.onTransitionEnd);
        this.removeEventListener('keydown', this.onKeyDown);
        window.removeEventListener('resize', this.onResize);
        this.ready = false;
      }

      clamp(index) {
        return Math.max(0, Math.min(index, this.total - 1));
      }

      prev(event) {
        if (event) event.preventDefault();
        if (this.animating || this.index <= 0) return;
        this.goTo(this.index - 1);
      }

      next(event) {
        if (event) event.preventDefault();
        if (this.animating || this.index >= this.total - 1) return;
        this.goTo(this.index + 1);
      }

      handleVisualClick(event) {
        var slide = event.target.closest('[data-eif-index]');
        if (!slide || !this.visual.contains(slide)) return;
        this.goTo(Number(slide.getAttribute('data-eif-index')));
      }

      handlePointerDown(event) {
        this.pointerX = event.clientX;
      }

      handlePointerUp(event) {
        if (typeof this.pointerX !== 'number') return;
        var delta = event.clientX - this.pointerX;
        this.pointerX = null;
        if (Math.abs(delta) < 40) return;
        if (delta > 0) this.prev();
        else this.next();
      }

      handleKeyDown(event) {
        if (event.key === 'ArrowLeft') this.prev(event);
        if (event.key === 'ArrowRight') this.next(event);
      }

      handleTransitionEnd(event) {
        if (event.target !== this.track || event.propertyName !== 'transform') return;
        this.animating = false;
      }

      handleResize() {
        this.updateTrack(true);
        this.syncContentHeight(true);
      }

      setActive(slides, index) {
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === index);
          slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
        });
      }

      syncContentHeight(instant) {
        if (!this.content || !this.contentSlides.length) return;
        var active = this.contentSlides[this.index];
        if (!active) return;

        if (instant) this.content.style.transition = 'none';
        this.content.style.height = active.offsetHeight + 'px';
        if (instant) {
          this.content.offsetHeight;
          this.content.style.transition = '';
        }
      }

      updateArrows() {
        var atStart = this.index <= 0;
        var atEnd = this.index >= this.total - 1;

        if (this.prevBtn) {
          this.prevBtn.disabled = atStart;
          this.prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        }
        if (this.nextBtn) {
          this.nextBtn.disabled = atEnd;
          this.nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
      }

      markActiveVisual() {
        var slides = this.track.querySelectorAll('.ee-inside-formula__visual-slide');
        slides.forEach(
          function (slide, slideIndex) {
            slide.classList.toggle('is-active', slideIndex === this.position);
          }.bind(this)
        );
      }

      getSizes() {
        var styles = window.getComputedStyle(this);
        return {
          active: parseFloat(styles.getPropertyValue('--eif-slide-active')) || 155,
          inactive: parseFloat(styles.getPropertyValue('--eif-slide-inactive')) || 96,
          gap: parseFloat(styles.getPropertyValue('--eif-slide-gap')) || 79
        };
      }

      updateTrack(instant) {
        if (!this.track || !this.visual) return;

        var sizes = this.getSizes();
        var left = 0;
        for (var i = 0; i < this.position; i++) {
          left += sizes.inactive + sizes.gap;
        }
        left += sizes.active / 2;

        var offset = this.visual.clientWidth / 2 - left;

        this.track.style.transition = instant ? 'none' : '';
        this.track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';

        if (instant) {
          this.track.offsetHeight;
          this.track.style.transition = '';
        }
      }

      goTo(index, silent) {
        if (!this.total) return;

        var nextIndex = this.clamp(index);
        var nextPosition = nextIndex;

        if (!silent && nextPosition !== this.position) this.animating = true;

        this.index = nextIndex;
        this.position = nextPosition;

        this.markActiveVisual();
        this.updateArrows();

        this.setActive(this.headingSlides, this.index);
        this.setActive(this.contentSlides, this.index);
        this.setActive(this.titleSlides, this.index);
        this.updateTrack(silent);
        this.syncContentHeight(silent);

        if (!silent) {
          this.dispatchEvent(
            new CustomEvent('eif:change', {
              detail: { index: this.index },
              bubbles: true
            })
          );
        }
      }
    }
  );
}
